import { Routes } from "react-router-dom";
import publicRoutes from "./PublicRoutes";
import privateRoutes from "./PrivateRoutes";
import { Suspense } from "react";
import { Box, CircularProgress } from "@mui/material";

const AppRoutes = () => {
  return (
    <Suspense
      fallback={
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <CircularProgress color="primary" />
        </Box>
      }
    >
      <Routes>
        {publicRoutes}
        {privateRoutes}
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
